import axios from "axios";

class Api {
    setDefaults() {
        // local override via env, falls back to production
        axios.defaults.baseURL =
            process.env.REACT_APP_API_URL || "https://dashboard-api.hanaficars.ir";
        // axios.defaults.baseURL = "http://localhost:4021";
    }
}

const api = new Api();
export {api};
 